import type { SortOption } from '@iconik-io/shared-lib/src/utils/sort/types';

import {
  SEARCH_SORTING_SETTINGS_KEY,
  SHARE_SORTING_SETTINGS_KEY,
} from '../constants/local_storage';
import {
  COLLECTION_PAGE_ROUTE,
  SEARCH_PAGE_ROUTE,
  SHARE_COLLECTION_PAGE_ROUTE,
} from '../constants/routes';
import { setSearchSorting } from '../ducks/pages/search/actions';
import { INITIAL_SEARCH_SORTING } from '../ducks/pages/search/constants';
import { routeParamsChange } from '../ducks/route_params/slice';
import type { AppMiddleware } from '../store/types';

const allowedSearchRoutes = [SEARCH_PAGE_ROUTE, COLLECTION_PAGE_ROUTE];

const allowedShareRoutes = [SHARE_COLLECTION_PAGE_ROUTE];

export function loadSortingSettings(
  storage: Storage,
  key: string,
): SortOption[] {
  const sortingSettingsJson = storage.getItem(key);

  let sortingSettingsParsed;

  if (sortingSettingsJson) {
    try {
      sortingSettingsParsed = JSON.parse(sortingSettingsJson);
    } catch (_error) {}
  }

  return sortingSettingsParsed;
}

const sortingSettingsManagerMiddleware: AppMiddleware =
  (api) => (next) => (action) => {
    const state = api.getState();
    const result = next(action);

    // Keep search/collection sort settings in localStorage every time we change sort settings on these pages.
    const allowedSearch = allowedSearchRoutes.includes(state.routeParams.route);
    if (allowedSearch && setSearchSorting.match(action)) {
      if (action.payload === INITIAL_SEARCH_SORTING) {
        localStorage.removeItem(SEARCH_SORTING_SETTINGS_KEY);
      } else {
        localStorage.setItem(
          SEARCH_SORTING_SETTINGS_KEY,
          JSON.stringify(action.payload),
        );
      }
    }
    // If navigation is made to a search/collection page, set settings to the one from the storage or
    // use a default settings if they don't exist.
    if (
      routeParamsChange.match(action) &&
      allowedSearchRoutes.includes(action.payload.route)
    ) {
      const sortOptions =
        loadSortingSettings(localStorage, SEARCH_SORTING_SETTINGS_KEY) ??
        INITIAL_SEARCH_SORTING;
      api.dispatch(setSearchSorting(sortOptions));
    }

    // Keep shared collection sort settings in sessionStorage every time we change sort settings on these pages.
    const allowedShare = allowedShareRoutes.includes(state.routeParams.route);
    if (allowedShare && setSearchSorting.match(action)) {
      if (action.payload === INITIAL_SEARCH_SORTING) {
        sessionStorage.removeItem(SHARE_SORTING_SETTINGS_KEY);
      } else {
        sessionStorage.setItem(
          SHARE_SORTING_SETTINGS_KEY,
          JSON.stringify(action.payload),
        );
      }
    }

    return result;
  };
export default sortingSettingsManagerMiddleware;
